import Fahrdienst452 from './Fahrdienst452.vue';
import Fahrdienst452Header from './Fahrdienst452Header.vue';
import moduleId from './moduleId';

// routes
export const ROUTE_FAHRDIENST = 'fahrdienst452';
export const ROUTE_FAHRDIENST_FILE = 'fahrdienst452File';
// tour routes
export const ROUTE_FAHRDIENST_TOUR_FILE = 'fahrdienst452TourFile'; //fahrdienst452/tour/:documentId
export const ROUTE_FAHRDIENST_TOUR_DATE_LINE_TRACK = 'fahrdienst452TourDateLineTrack'; //fahrdienst452/tour/:dateYYYYMMDD/:line/:track
export const ROUTE_FAHRDIENST_TOUR_DATE_LINE_TRACK_FILE = 'fahrdienst452TourDateLineTrackFile'; //fahrdienst452/tour/:dateYYYYMMDD/:line/:track/:documentId
export const ROUTE_FAHRDIENST_TOUR_DATE = 'fahrdienst452TourDate'; //fahrdienst452/tour/:dateYYYYMMDD
export const ROUTE_FAHRDIENST_TOUR_DATE_FILE = 'fahrdienst452TourDateFile'; //fahrdienst452/tour/:dateYYYYMMDD/:documentId
export const ROUTE_FAHRDIENST_TOUR_LINE_TRACK = 'fahrdienst452TourLineTrack'; //fahrdienst452/tour/:line/:track
export const ROUTE_FAHRDIENST_TOUR_LINE_TRACK_FILE = 'fahrdienst452TourLineTrackFile'; //fahrdienst452/tour/:line/:track/:documentId
// hash routes
export const ROUTE_FAHRDIENST_HASH_FILE = 'fahrdienst452HashFile'; //fahrdienst452/tour-with-hash/:documentId
export const ROUTE_FAHRDIENST_HASH_DATE_TOUR = 'fahrdienst452HashDateTour'; //fahrdienst452/tour-with-hash/:dateYYYYMMDD/:tourHash
export const ROUTE_FAHRDIENST_HASH_DATE_TOUR_FILE = 'fahrdienst452HashDateTourFile'; //fahrdienst452/tour-with-hash/:dateYYYYMMDD/:tourHash/:documentId
export const ROUTE_FAHRDIENST_HASH_DATE = 'fahrdienst452HashDate'; //fahrdienst452/tour-with-hash/:dateYYYYMMDD
export const ROUTE_FAHRDIENST_HASH_DATE_FILE = 'fahrdienst452HashDateFile'; //fahrdienst452/tour-with-hash/:dateYYYYMMDD/:documentId
export const ROUTE_FAHRDIENST_HASH_TOUR = 'fahrdienst452HashTour'; //fahrdienst452/tour-with-hash/:tourHash
export const ROUTE_FAHRDIENST_HASH_TOUR_FILE = 'fahrdienst452HashTourFile'; //fahrdienst452/tour-with-hash/:tourHash/:documentId

class Fahrdienst452RouteHandler {
  getRoutes = ({ moduleType, router }) => {
    const initiateSyncBeforeNav = false;
    console.debug('define fahrdienst452RouteHandler', moduleType, moduleId);
    return [
      // basic routes
      {
        path: '/fahrdienst452',
        name: ROUTE_FAHRDIENST,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      {
        path: '/fahrdienst452/document/:documentId',
        name: ROUTE_FAHRDIENST_FILE,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      // tour routes
      {
        path: '/fahrdienst452/tour/file/:documentId',
        name: ROUTE_FAHRDIENST_TOUR_FILE,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      {
        path: '/fahrdienst452/tour/date-line-track/:dateYYYYMMDD/:line/:track',
        name: ROUTE_FAHRDIENST_TOUR_DATE_LINE_TRACK,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      {
        path: '/fahrdienst452/tour/date-line-track-file/:dateYYYYMMDD/:line/:track/:documentId',
        name: ROUTE_FAHRDIENST_TOUR_DATE_LINE_TRACK_FILE,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      {
        path: '/fahrdienst452/tour/date/:dateYYYYMMDD',
        name: ROUTE_FAHRDIENST_TOUR_DATE,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      {
        path: '/fahrdienst452/tour/date-file/:dateYYYYMMDD/:documentId',
        name: ROUTE_FAHRDIENST_TOUR_DATE_FILE,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      {
        path: '/fahrdienst452/tour/line-track/:line/:track',
        name: ROUTE_FAHRDIENST_TOUR_LINE_TRACK,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      {
        path: '/fahrdienst452/tour/line-track-file/:line/:track/:documentId',
        name: ROUTE_FAHRDIENST_TOUR_LINE_TRACK_FILE,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      // hash routes
      {
        path: '/fahrdienst452/tour-with-hash/file/:documentId',
        name: ROUTE_FAHRDIENST_HASH_FILE,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      {
        path: '/fahrdienst452/tour-with-hash/date-hash/:dateYYYYMMDD/:tourHash',
        name: ROUTE_FAHRDIENST_HASH_DATE_TOUR,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      {
        path: '/fahrdienst452/tour-with-hash/date-hash-file/:dateYYYYMMDD/:tourHash/:documentId',
        name: ROUTE_FAHRDIENST_HASH_DATE_TOUR_FILE,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      {
        path: '/fahrdienst452/tour-with-hash/date/:dateYYYYMMDD',
        name: ROUTE_FAHRDIENST_HASH_DATE,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      {
        path: '/fahrdienst452/tour-with-hash/date-file/:dateYYYYMMDD/:documentId',
        name: ROUTE_FAHRDIENST_HASH_DATE_FILE,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      {
        path: '/fahrdienst452/tour-with-hash/hash/:tourHash',
        name: ROUTE_FAHRDIENST_HASH_TOUR,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
      {
        path: '/fahrdienst452/tour-with-hash/hash-file/:tourHash/:documentId',
        name: ROUTE_FAHRDIENST_HASH_TOUR_FILE,
        meta: { moduleType, initiateSyncBeforeNav, moduleId, baseRoute: true },
        components: { default: Fahrdienst452, header: Fahrdienst452Header },
      },
    ];
  };
}

const routeHandler = new Fahrdienst452RouteHandler();
export default routeHandler;
